export const filterTypeItems = [
  // { label: "On Sale", value: "on_sale", checked: false },
  // { label: "Nearby", value: "nearby", checked: false },
  // {
  //   label: "Currently Open",
  //   value: "currently_open",
  //   checked: false,
  // },
  {
    label: "Top Rated",
    value: "top_rated",
    checked: false,
  },
  { label: "Discounted", value: "discounted", checked: false },
  //{ label: "From Campaign", value: "from_campaign", checked: false },
  {
    label: "Popular",
    value: "popular",
    checked: false,
  },
  {
    label: "Price",
    value: "price",
    price: [],
    checked: false,
  },
  {
    label: "Ratings",
    value: "ratings",
    rating: 0,
    checked: false,
  },
  {
    label: "",
    value: "test",
    checked: true,
  },
];

export const filterTypeStores = [
  // { label: "On Sale", value: "on_sale", checked: false },
  { label: "Nearby", value: "nearby", checked: false },
  {
    label: "Currently Open",
    value: "currently_open",
    checked: false,
  },
  {
    label: "Top Rated",
    value: "top_rated",
    checked: false,
  },
  { label: "Discounted", value: "discounted", checked: false },
  { label: "From Campaign", value: "from_campaign", checked: false },
  {
    label: "Popular",
    value: "popular",
    checked: false,
  },
  {
    label: "Best Seller",
    value: "best_seller",
    checked: false,
  },
  // {
  //   label: "Price",
  //   value: "price",
  //   price: [],
  //   checked: true,
  // },
  {
    label: "Ratings",
    value: "ratings",
    rating: 0,
    checked: false,
  },
];
